import { getRequest } from '@/core';
import { packageTypes } from '@/requests';

export default async function getPackageTypesRequest() {
	let url = packageTypes.getPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}